import React from 'react';
import * as styles from './ExpandedPostModalAnnotation.module.scss';
import Button from '../../components/Button';
import PopOver from '../../components/deprecated/PopOver';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import { sanitizeAnnotationLink } from '../../utils/url/sanitizeUrl';
import { AnnotationPreviewContainer } from '../annotation/Annotation';
import AnnotationIcon from '../annotation/AnnotationIcon';
import AnnotationLink from '../annotation/AnnotationLink';
import AnnotationPreview from '../annotation/AnnotationPreview';
import isContentEmpty from '../utils/isContentEmpty';

const ANNOTATION_FRAGMENT = gql(`
  fragment ExpandedPostModalAnnotation_annotation on Annotation {
    id
    content
    link
    linkText
  }
`);

interface ExpandedPostModalAnnotationProps {
  annotation: DocumentType<typeof ANNOTATION_FRAGMENT>;
  compact: boolean;
  activeThreadId: string | null;
  onActiveThreadIdChange: (threadId: string | null) => void;
}

const ExpandedPostModalAnnotation = ({
  annotation,
  compact,
  activeThreadId,
  onActiveThreadIdChange,
}: ExpandedPostModalAnnotationProps) => {
  const sanitizedLink =
    annotation.link && sanitizeAnnotationLink(annotation.link);
  const trimmedLinkText = annotation.linkText?.trim() ?? '';

  const shouldShowLink = !isContentEmpty(annotation.content) && sanitizedLink;

  return (
    <div>
      <PopOver
        placement="left-start"
        trigger="click"
        onOpenChange={(newIsOpen) => {
          onActiveThreadIdChange(newIsOpen ? annotation.id : null);
        }}
        open={activeThreadId === annotation.id}
        preventCloseOnContentClick
        popOver={
          <div className={styles.container}>
            <AnnotationPreviewContainer>
              <AnnotationPreview
                annotation={annotation}
                avatar={<AnnotationIcon />}
              />
            </AnnotationPreviewContainer>
            {shouldShowLink && (
              <AnnotationLink link={sanitizedLink} text={trimmedLinkText} />
            )}
          </div>
        }
      >
        {compact ? (
          <Button icon={<AnnotationIcon size="small" />} />
        ) : (
          <Button icon={<AnnotationIcon hoverable />} />
        )}
      </PopOver>
    </div>
  );
};

export default ExpandedPostModalAnnotation;
